export default __webpack_public_path__ + "static/top-banner-c8c017fbbddf56eeabb4c60c068a6f32.png";